import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useTheme } from "@mui/material";
import { CardWraper } from "@ui/components/cards/CardWraper";
import { useEffect, useMemo, useState } from "react";
import Grid from "@mui/material/Grid2";
import { HInput } from "@ui/components/inputs/HInput";
import { Icon } from "@iconify/react";
import { HSelect } from "@ui/components/inputs/HSelect";
import { HDatePicker } from "@ui/components/inputs/HDatePicker";
import { SteperHeader } from "@ui/components/Header/SteperHeader";
import { between, stack3 } from "@ui/style/style";
import { GetByPersonAsync } from "@application/features/children/childrenThunk";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { EIconButton } from "@ui/components/event/button/EIconButton";
import { useTranslation } from "react-i18next";
import { validateDate, validateIsFutureDate } from "@ui/constants/Helper";
export const ChildrenInfoForm = ({ control, errors, childrenCount, personId, formMod = "edit", onChildrenChange, setValue, }) => {
    const [children, setChildren] = useState([]);
    const { Children } = useAppSelector((state) => state.children);
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();
    // useEffect(() => {
    //   // Only set children based on childrenCount if there are no Children in state
    //   if (!Children || Children.length === 0) {
    //     const newChildren = Array.from({ length: childrenCount }, (_, i) => ({
    //       index: i,
    //     }));
    //     setChildren(newChildren);
    //     onChildrenChange(newChildren); // Notify parent
    //   }
    // }, [childrenCount, Children]);
    useEffect(() => {
        const newChildren = Array.from({ length: childrenCount }, (_, i) => ({
            index: i,
        }));
        setChildren(newChildren);
        onChildrenChange(newChildren); // Notify parent
    }, [childrenCount]);
    useEffect(() => {
        if (personId) {
            dispatch(GetByPersonAsync(personId));
        }
    }, [personId]);
    // useEffect(() => {
    //   if (setValue && formMod !== "view") {
    //     // For each adult, register a listener for the firstName field
    //     children.forEach((child, index) => {
    //       const fieldName = `ChildrenInfo[${index}].FirstName`;
    //       // Register the field with an onChange handler
    //       control.register(fieldName, {
    //         onChange: (e: { target?: any; type?: string }) => {
    //           // Only mark as touched/dirty if this is a user-initiated event
    //           if (e.target && e.type === "change") {
    //             // This is a manual change by the user
    //             if (control._fields[fieldName]) {
    //               control._fields[fieldName]._f.touched = true;
    //               control._fields[fieldName]._f.isDirty = true;
    //             }
    //           }
    //         },
    //       });
    //     });
    //   }
    // }, [children, control, setValue, formMod]);
    useEffect(() => {
        if (Children) {
            if (!Children || Children.length === 0) {
                // Set default values using setValue instead of reset
                if (setValue) {
                    setValue("ChildrenInfo", [
                        {
                            FirstName: "",
                            MiddleName: "",
                            LastName: "",
                            Relationship: "",
                            DateOfBirth: "",
                            Gender: "",
                            ShirtSize: "",
                        },
                    ]
                    // { shouldValidate: false }
                    );
                    setValue("ChildrenInfo[0].FirstName", "");
                    setValue("ChildrenInfo[0].MiddleName", "");
                    setValue("ChildrenInfo[0].LastName", "");
                    setValue("ChildrenInfo[0].Relationship", "");
                    setValue("ChildrenInfo[0].DateOfBirth", "");
                    setValue("ChildrenInfo[0].Gender", "");
                    setValue("ChildrenInfo[0].ShirtSize", "");
                }
                return;
            }
            if (Children?.length > 0 && setValue) {
                const updatedChildren = Children.map((child, i) => ({
                    index: i,
                    id: child.id,
                }));
                // setChildren(updatedChildren);
                onChildrenChange(updatedChildren); // Notify parent
                // Set default values for each child
                Children.forEach((child, index) => {
                    setValue(`ChildrenInfo[${index}].FirstName`, child.firstName || "");
                    setValue(`ChildrenInfo[${index}].MiddleName`, child.middleName || "");
                    setValue(`ChildrenInfo[${index}].LastName`, child.lastName || "");
                    setValue(`ChildrenInfo[${index}].Relationship`, child.relationship || "");
                    setValue(`ChildrenInfo[${index}].DateOfBirth`, child.dateOfBirth || "");
                    setValue(`ChildrenInfo[${index}].Gender`, child.gender || "");
                    setValue(`ChildrenInfo[${index}].ShirtSize`, child.shirtSize || "");
                });
                // Update the entire ChildrenInfo array
                const formValues = Children.map((child) => ({
                    FirstName: child.firstName || "",
                    MiddleName: child.middleName || "",
                    LastName: child.lastName || "",
                    Relationship: child.relationship || "",
                    DateOfBirth: child.dateOfBirth || "",
                    Gender: child.gender || "",
                    ShirtSize: child.shirtSize || "",
                }));
                setValue("ChildrenInfo", formValues);
            }
        }
    }, [Children, setValue]);
    const addChild = () => {
        setChildren((prev) => {
            const newIndex = prev.length;
            const updatedChildren = [...prev, { index: newIndex }];
            // Initialize form fields for the new child with empty values
            if (setValue) {
                setValue(`ChildrenInfo[${newIndex}].FirstName`, "");
                setValue(`ChildrenInfo[${newIndex}].MiddleName`, "");
                setValue(`ChildrenInfo[${newIndex}].LastName`, "");
                setValue(`ChildrenInfo[${newIndex}].Relationship`, "");
                setValue(`ChildrenInfo[${newIndex}].DateOfBirth`, "");
                setValue(`ChildrenInfo[${newIndex}].Gender`, "");
                setValue(`ChildrenInfo[${newIndex}].ShirtSize`, "");
                // Get current form values
                const currentFormValues = control._formValues.ChildrenInfo || [];
                // Add empty values for the new child
                const newFormValues = [...currentFormValues];
                newFormValues[newIndex] = {
                    FirstName: "",
                    MiddleName: "",
                    LastName: "",
                    Relationship: "",
                    DateOfBirth: "",
                    Gender: "",
                    ShirtSize: "",
                };
                // Update the entire ChildrenInfo array
                setValue("ChildrenInfo", newFormValues);
            }
            onChildrenChange(updatedChildren); // Notify parent
            return updatedChildren;
        });
    };
    const removeChild = (indexToRemove) => {
        setChildren((prev) => {
            // Remove the child at the specified index
            const updatedChildren = prev.filter((child) => child.index !== indexToRemove);
            // Reindex remaining children to ensure sequential indices
            const reindexedChildren = updatedChildren.map((child, newIndex) => ({
                ...child,
                index: newIndex,
            }));
            // Get current form values
            const currentFormValues = control._formValues.ChildrenInfo || [];
            // Create new array without the removed index
            const newFormValues = currentFormValues.filter((_, i) => i !== indexToRemove);
            // Update form values for all fields
            if (setValue) {
                // First unregister all child fields at the removed index
                const fieldsToUnregister = [
                    `ChildrenInfo[${indexToRemove}].FirstName`,
                    `ChildrenInfo[${indexToRemove}].MiddleName`,
                    `ChildrenInfo[${indexToRemove}].LastName`,
                    `ChildrenInfo[${indexToRemove}].Relationship`,
                    `ChildrenInfo[${indexToRemove}].DateOfBirth`,
                    `ChildrenInfo[${indexToRemove}].Gender`,
                    `ChildrenInfo[${indexToRemove}].ShirtSize`,
                ];
                fieldsToUnregister.forEach((field) => {
                    control.unregister(field);
                });
                // Set values for remaining children with their new indices
                newFormValues.forEach((child, newIndex) => {
                    setValue(`ChildrenInfo[${newIndex}].FirstName`, child.FirstName || "");
                    setValue(`ChildrenInfo[${newIndex}].MiddleName`, child.MiddleName || "");
                    setValue(`ChildrenInfo[${newIndex}].LastName`, child.LastName || "");
                    setValue(`ChildrenInfo[${newIndex}].Relationship`, child.Relationship || "");
                    setValue(`ChildrenInfo[${newIndex}].DateOfBirth`, child.DateOfBirth || "");
                    setValue(`ChildrenInfo[${newIndex}].Gender`, child.Gender || "");
                    setValue(`ChildrenInfo[${newIndex}].ShirtSize`, child.ShirtSize || "");
                });
                // Update the entire ChildrenInfo array to remove the empty entry
                setValue("ChildrenInfo", newFormValues);
            }
            onChildrenChange(reindexedChildren); // Notify parent with reindexed children
            return reindexedChildren;
        });
    };
    const theme = useTheme();
    const relationshipOptions = useMemo(() => [
        {
            label: t(`event.relationships.Son`),
            value: "Son",
        },
        {
            label: t(`event.relationships.Daughter`),
            value: "Daughter",
        },
        {
            label: t(`event.relationships.SonInLaw`),
            value: "SonInLaw",
        },
        {
            label: t(`event.relationships.DaughterInLaw`),
            value: "DaughterInLaw",
        },
        {
            label: t(`event.relationships.Grandson`),
            value: "Grandson",
        },
        {
            label: t(`event.relationships.Granddaughter`),
            value: "Granddaughter",
        },
    ], [t, i18n.language]);
    return (_jsxs("div", { children: [_jsx(SteperHeader, { title: t("event.childrenInformation") }), _jsx(Box, { sx: { ...stack3, mt: 0.5 }, children: children.map((childIndex) => (_jsx(CardWraper, { children: _jsxs(Grid, { container: true, spacing: 1, children: [_jsx(Grid, { size: 12, children: _jsxs(Box, { sx: { ...between }, children: [_jsxs(Typography, { variant: "body1", color: "initial", children: [t("event.children"), _jsx(Box, { component: "span", sx: {
                                                        fontSize: 12,
                                                        width: "28px !important",
                                                        height: "28px !important",
                                                        color: theme.palette.primary.contrastText,
                                                        fontWeight: 500,
                                                        backgroundColor: theme.palette.primary.light,
                                                        alignContent: "center",
                                                        textAlign: "center",
                                                        display: "inline-block",
                                                        borderRadius: "50%",
                                                        verticalAlign: "middle",
                                                        ml: 1,
                                                    }, children: childIndex.index + 1 })] }), _jsx(EIconButton, { disabled: formMod === "view" ||
                                                childIndex.index ===
                                                    (children.length - 1 && childIndex.index === 0), onClick: () => removeChild(childIndex.index), children: _jsx(Icon, { icon: "mingcute:close-line", width: "16", height: "16" }) })] }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(HInput, { backgroundColor: "white", label: t("formFields.firstName"), name: `ChildrenInfo[${childIndex.index}].FirstName`, control: control, rules: {
                                        value: true,
                                        required: "validations.firstNameRequired",
                                    }, 
                                    // rules={{
                                    //   validate: (value) => {
                                    //     // If the field has a value but hasn't been touched by user,
                                    //     // skip validation to prevent errors on initial load
                                    //     const fieldName = `ChildrenInfo[${childIndex.index}].FirstName`;
                                    //     const field = control._fields?.[fieldName];
                                    //     if (value && !field?._f.touched && !field?._f.isDirty) {
                                    //       return true;
                                    //     }
                                    //     // Regular validation when field is touched/dirty
                                    //     return value ? true : "validations.firstNameRequired";
                                    //   },
                                    // }}
                                    disabled: formMod === "view" ? true : false, error: errors?.ChildrenInfo?.[childIndex.index]?.FirstName?.message }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(HInput, { label: t("formFields.middleName"), backgroundColor: "white", disabled: formMod === "view" ? true : false, name: `ChildrenInfo[${childIndex.index}].MiddleName`, control: control }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(HInput, { label: t("formFields.lastName"), name: `ChildrenInfo[${childIndex.index}].LastName`, backgroundColor: "white", disabled: formMod === "view" ? true : false, control: control, 
                                    // rules={{
                                    //   validate: (value) => {
                                    //     // If the field has a value but hasn't been touched by user,
                                    //     // skip validation to prevent errors on initial load
                                    //     const fieldName = `ChildrenInfo[${childIndex.index}].LastName`;
                                    //     const field = control._fields?.[fieldName];
                                    //     if (value && !field?._f.touched && !field?._f.isDirty) {
                                    //       return true;
                                    //     }
                                    //     // Regular validation when field is touched/dirty
                                    //     return value ? true : "validations.lastNameRequired";
                                    //   },
                                    // }}
                                    rules: {
                                        value: true,
                                        required: "validations.lastNameRequired",
                                    }, error: errors?.ChildrenInfo?.[childIndex.index]?.LastName?.message }) }), _jsx(Grid, { size: { xs: 12, sm: 6, md: 6 }, children: _jsx(HSelect, { control: control, disabled: formMod === "view" ? true : false, label: t("formFields.relationship"), backgroundColor: "white", name: `ChildrenInfo[${childIndex.index}].Relationship`, options: relationshipOptions, rules: {
                                        value: true,
                                        required: "validations.relationshipRequired",
                                    }, 
                                    // rules={{
                                    //   validate: (value) => {
                                    //     // If the field has a value but hasn't been touched by user,
                                    //     // skip validation to prevent errors on initial load
                                    //     const fieldName = `ChildrenInfo[${childIndex.index}].Relationship`;
                                    //     const field = control._fields?.[fieldName];
                                    //     if (value && !field?._f.touched && !field?._f.isDirty) {
                                    //       return true;
                                    //     }
                                    //     // Regular validation when field is touched/dirty
                                    //     return value ? true : "validations.Relationship";
                                    //   },
                                    // }}
                                    error: errors?.ChildrenInfo?.[childIndex.index]?.Relationship
                                        ?.message }) }), _jsx(Grid, { size: { xs: 12, sm: 6, md: 6 }, children: _jsx(HDatePicker, { label: t("formFields.dateOfBirth"), backgroundColor: "white", disabled: formMod === "view" ? true : false, control: control, name: `ChildrenInfo[${childIndex.index}].DateOfBirth`, errormsg: errors?.ChildrenInfo?.[childIndex.index]?.DateOfBirth
                                        ?.message, rules: {
                                        required: {
                                            value: true,
                                            message: "validations.dateOfBirthRequired",
                                        },
                                        validate: {
                                            isValidDate: (value) => {
                                                return validateDate(value);
                                            },
                                            notFutureDate: (value) => {
                                                return validateIsFutureDate(value);
                                            },
                                        },
                                    }, disableFuture: true }) })] }) }, childIndex.index))) })] }));
};
